import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import { List, ListGroup, ListDivider, ListItem, } from 'rmwc/List';
import {default as Reactsel} from 'react-select';
import StarRatings from 'react-star-ratings';
import { Snackbar } from 'rmwc/Snackbar';
import AdminIndividualExtResComponent from './AdminIndividualExtResComponent'

class AdminExternalResource extends Component {
	constructor(props) {
    	super(props)
    	this.state = {
            addFormOpen: false,
            errorMsg: '',
            uploadFormOpen: false,
            snackbarIsOpen: false,
    		initialData: {
    			competencyId: '',
    			levelId: '',
    			trackId: ''
    		},
    		data:{
    			externalResourceDetails: [],
                artifactURL: '',
                uploadStatus: '',
                uploadDisabled: true,
                uploadedResourceId: '',
                artifactUpload: ''
    		},
            externalData:{
                externalResourceName: '',
                externalResourceLink: '',
                externalAuthor: '',
                externalDescription: '',
                comboLevels: [],
                comboTracks: []
            },
            externalSelectedTracks: [],
            externalSelectedLevels: [],
            uploadDisableButton: true,
            addDisableButton: false,
            fileError: ''
    	};
    }

    handleAddFormOpen = (e) => {
        e.preventDefault()
        this.setState({ addFormOpen: true, uploadFormOpen: false, errorMsg: '', fileError: ''});
    }

    handleUploadFormOpen = (e) => {
        e.preventDefault()
        this.setState({ uploadFormOpen: true, addFormOpen: false, errorMsg: '', fileError: ''});
    }

    handleAddFormClose = (e) => {
        e.preventDefault()
        let extData = Object.assign({}, this.state.externalData)
        extData = {
            'externalResourceName' : '',
            'externalResourceLink' : '',
            'externalAuthor': '',
            'externalDescription': '',
            'comboLevels': this.state.externalData.comboLevels,
            'comboTracks': this.state.externalData.comboTracks
        }
        let externalSelectedTracks = Object.assign({}, this.state.externalSelectedTracks)
        let externalSelectedLevels = Object.assign({}, this.state.externalSelectedLevels)
        externalSelectedLevels = []
        externalSelectedTracks = []
        this.setState({addFormOpen: false, uploadFormOpen: false, externalData: extData, externalSelectedTracks: externalSelectedTracks, externalSelectedLevels: externalSelectedLevels, errorMsg: '', fileError: ''})
    }

    handleUploadFormClose = (e) => {
        e.preventDefault()
        let extData = Object.assign({}, this.state.externalData)
        extData = {
            'externalResourceName' : '',
            'externalAuthor': '',
            'externalDescription': '',
            'comboLevels': this.state.externalData.comboLevels,
            'comboTracks': this.state.externalData.comboTracks
        }
        let externalSelectedTracks = Object.assign({}, this.state.externalSelectedTracks)
        let externalSelectedLevels = Object.assign({}, this.state.externalSelectedLevels)
        externalSelectedLevels = []
        externalSelectedTracks = []
        this.setState({uploadFormOpen: false, addFormOpen: false, externalData: extData, externalSelectedTracks: externalSelectedTracks, externalSelectedLevels: externalSelectedLevels, errorMsg: '', fileError: '', uploadDisableButton: true})
    }

    handleResourceUpload =(e) =>{
        e.preventDefault()
        let type = 1

        if ((this.state.externalData.externalResourceName == '') || (this.state.externalData.externalAuthor == '') || (this.state.externalData.externalDescription == '') || (this.state.externalSelectedLevels == '') || (this.state.externalSelectedTracks == '')) {
            return this.setState({errorMsg: 'Please enter the necessary details before uploading a new resource.'})
        }

        this.setState({uploadDisableButton: true})
        const formData = new FormData(e.target);

        var myStringArray = this.state.externalSelectedLevels;
        var arrayLength = myStringArray.length;
        let selectedLevelsString 
        for (var i = 0; i < arrayLength; i++) {
            if(i == 0)
                selectedLevelsString = myStringArray[i].value
            else
                selectedLevelsString = selectedLevelsString + "," + myStringArray[i].value
        }

        var myStringArray = this.state.externalSelectedTracks;
        var arrayLength = myStringArray.length;
        let selectedTracksString 
        for (var i = 0; i < arrayLength; i++) {
            if(i == 0)
                selectedTracksString = myStringArray[i].value
            else
                selectedTracksString = selectedTracksString + "," + myStringArray[i].value
        }

        formData.append("selected_levels_list", selectedLevelsString)
        formData.append("selected_tracks_list", selectedTracksString)

        api.uploadAdminResource(this.props.user.accessToken, formData, this.props.competencyId, type)
        .then((result) => {
            if(result.status == 'success'){
                let extData = Object.assign({}, this.state.externalData)
                extData = {
                    'externalResourceName' : '',
                    'externalAuthor': '',
                    'externalDescription': '',
                    'comboLevels': this.state.externalData.comboLevels,
                    'comboTracks': this.state.externalData.comboTracks
                }
                let externalSelectedTracks = Object.assign({}, this.state.externalSelectedTracks)
                let externalSelectedLevels = Object.assign({}, this.state.externalSelectedLevels)
                externalSelectedLevels = []
                externalSelectedTracks = []
                this.setState({snackbarIsOpen: !this.state.snackbarIsOpen, uploadFormOpen: false, externalData: extData, externalSelectedTracks: externalSelectedTracks, externalSelectedLevels: externalSelectedLevels, errorMsg: '', uploadDisableButton: true})
            }
            else {
                this.setState({errorMsg: 'Error while uploading a new External Resource.', uploadDisableButton: false})
            }
        }).catch((err) => {
            this.setState({ errorMsg: 'Error in uploading the External Resources. Please contact Admin!', uploadDisableButton: false})
        })
    }

    handleExternalResourceSave = (e) => {
        e.preventDefault()

        if ((this.state.externalData.externalResourceName == '') || (this.state.externalData.externalResourceLink == '') || (this.state.externalData.externalAuthor == '') || (this.state.externalData.externalDescription == '') || (this.state.externalSelectedLevels == '') || (this.state.externalSelectedTracks == '')) {
            return this.setState({errorMsg: 'Please enter the necessary details before adding a new resource.'})
        }

        this.setState({addDisableButton: true})

        let type = 1
        let selectedTracksList = []
        let selectedLevelsList = []
        let data = {
            'name' : this.state.externalData.externalResourceName,
            'resourceLink' : this.state.externalData.externalResourceLink,
            'resourceauthor': this.state.externalData.externalAuthor,
            'resourcedesc': this.state.externalData.externalDescription,
            'selectedLevelsList' : this.state.externalSelectedLevels,
            'selectedTracksList' : this.state.externalSelectedTracks
        }
        api.addAdminResource(this.props.user.accessToken, data, this.props.competencyId, type)
        .then((result) => {
            if (result.status == 'success') {
                let extData = Object.assign({}, this.state.externalData)
                extData = {
                    'externalResourceName' : '',
                    'externalResourceLink' : '',
                    'externalAuthor': '',
                    'externalDescription': '',
                    'comboLevels': this.state.externalData.comboLevels,
                    'comboTracks': this.state.externalData.comboTracks
                }
                let externalSelectedTracks = Object.assign({}, this.state.externalSelectedTracks)
                let externalSelectedLevels = Object.assign({}, this.state.externalSelectedLevels)
                externalSelectedLevels = []
                externalSelectedTracks = []
                this.setState({addFormOpen: false, externalData: extData, externalSelectedTracks: externalSelectedTracks, externalSelectedLevels: externalSelectedLevels, errorMsg: '', addDisableButton: false})
            }
            else {
                this.setState({errorMsg: 'Error while adding a new External Resource.', addDisableButton: false})
            }
        }).catch((err) => {
            this.setState({ errorMsg: 'Error in adding the External Resources. Please contact Admin!', addDisableButton: false})
        })
    }

    validateUpload = (event) =>{
        let uploadDisableButton
        let file_name = event.target.files[0].name;
        let extension = file_name.substring(file_name.lastIndexOf('.') + 1).toLowerCase();
        let fileError

        if (extension == "pdf"){
            fileError = ''
            this.setState({uploadDisableButton: false, fileError: fileError})
        }
        else{
            fileError = 'Invalid File Format. Upload PDF file only.'
            this.setState({uploadDisableButton: true, fileError: fileError})
        }
    }

    handleExternalNameChange = (event) => {
        let externalData = Object.assign({}, this.state.externalData)
        externalData.externalResourceName = event.target.value
        this.setState({externalData: externalData}) 
    }

    handleExternalAuthorChange = (event) => {
        let externalData = Object.assign({}, this.state.externalData)
        externalData.externalAuthor = event.target.value
        this.setState({externalData: externalData}) 
    }

    handleExternalDescChange = (event) => {
        let externalData = Object.assign({}, this.state.externalData)
        externalData.externalDescription = event.target.value
        this.setState({externalData: externalData}) 
    }

    handleExternalLinkChange = (event) => {
        let externalData = Object.assign({}, this.state.externalData)
        externalData.externalResourceLink = event.target.value
        this.setState({externalData: externalData}) 
    }

    handleExtAssociatedLevels = (option) => {
        this.setState(state => {
            return {
               externalSelectedLevels : option
            };
        });
    }

    handleExtAssociatedTracks = (option) => {
        this.setState(state => {
            return {
               externalSelectedTracks : option
            };
        });
    }

    componentDidMount() {
    	let initialData = Object.assign({}, this.state.initialData)
        let externalData = Object.assign({}, this.state.externalData)
    	let data = Object.assign({}, this.state.data)
    	initialData.competencyId = this.props.competencyId
    	this.setState({initialData: initialData})

    	
        return api.adminResourceLevelsBox(this.props.user.accessToken)
            .then((result) => {
                externalData.comboLevels = result.data
                api.adminResourceTracksBox(this.props.user.accessToken)
                .then((result) => {
                    externalData.comboTracks = result.data
                    this.setState({externalData: externalData})
                })
            })
    
    }

    render() {
    	let externalComponent
        let externalRating
        let uploadButtonComponent
        let addButtonComponent
        let externalAddCompenent
        let handleAddFormOpen = this.handleAddFormOpen
        let handleAddFormClose = this.handleAddFormClose
        let handleUploadFormOpen = this.handleUploadFormOpen
        let handleUploadFormClose = this.handleUploadFormClose
        let handleExternalResourceSave = this.handleExternalResourceSave
        let handleResourceUpload = this.handleResourceUpload

        let Snackbarcomponent =(
            <Snackbar
                show={this.state.snackbarIsOpen}
                onHide={evt => this.setState({snackbarIsOpen: false})}
                message="Upload Successful"
            />
        )

        if(this.state.uploadDisableButton == false){
            uploadButtonComponent = (<Button raised style={{ width: '100%' }}>Save</Button>)
        }
        else{
            uploadButtonComponent = (<Button raised disabled style={{ width: '100%' }}>Save</Button>)
        }

        if(this.state.addDisableButton == false){
            addButtonComponent = (<Button raised style={{ width: '100%' }} onClick= {((e) => handleExternalResourceSave(e))}>Save</Button>)
        }
        else{
            addButtonComponent = (<Button raised disabled style={{ width: '100%' }}>Save</Button>)
        }

        if (this.state.addFormOpen) {
           externalAddCompenent = (
                <div>
                    <Grid> 
                        <GridCell span="5">
                            <TextField fullwidth className = 'test_input' label="Name of the Resource" autoComplete="off"  name="name" value = {this.state.externalData.externalResourceName} onChange = {this.handleExternalNameChange} style={{ height: '140%' }}/>
                        </GridCell>
                        <GridCell span="7">
                            <TextField fullwidth className = 'test_input' label ="Link for the Resource"  autoComplete="off"  name="name" value = {this.state.externalData.externalResourceLink} onChange = {this.handleExternalLinkChange} style={{ height: '140%' }}/>
                        </GridCell>
                    </Grid>
                    <Grid>
                        <GridCell span="5">
                            <Reactsel
                                name="levelslist"
                                onChange={this.handleExtAssociatedLevels}
                                value={this.state.externalSelectedLevels}
                                options={this.state.externalData.comboLevels}
                                placeholder="--Select Level--"
                                isMulti>
                            </Reactsel>
                        </GridCell>

                        <GridCell span="7">
                            <Reactsel
                                name="levelslist"
                                onChange={this.handleExtAssociatedTracks}
                                value={this.state.externalSelectedTracks}
                                options={this.state.externalData.comboTracks}
                                placeholder="--Select Track--"
                                isMulti>
                            </Reactsel>
                        </GridCell>
                    </Grid>
                    <Grid>
                        <GridCell span="3">
                            <TextField fullwidth label="Author" name="resourceauthor" value = {this.state.externalData.externalAuthor} onChange={this.handleExternalAuthorChange} style={{ height: '140%' }}/>
                        </GridCell>
                        <GridCell span="9">
                            <TextField textarea fullwidth label="Description" rows="1" name="resourcedesc" value = {this.state.externalData.externalDescription} onChange={this.handleExternalDescChange} />
                        </GridCell>
                    </Grid>
                    <Grid>
                        <GridCell span="4"> 
                            {addButtonComponent}
                        </GridCell>
                        <GridCell span="4">
                            <Button style={{ width: '100%' }} onClick= {((e) => handleAddFormClose(e))}>Cancel</Button>
                        </GridCell>
                        <GridCell span="2">
                        </GridCell>
                    </Grid>
                    <StatusMessage error_msg = {this.state.errorMsg} />
                </div>
            )
        }

        if (this.state.uploadFormOpen) {
           externalAddCompenent = (
                <div>
                    <form onSubmit= {((e) => this.handleResourceUpload(e))} style={{ width: '100%' }}>
                    <Grid> 
                        <GridCell span="12">
                            <TextField fullwidth className = 'test_input' label="Name of the Resource" autoComplete="off"  name="resourcename" value = {this.state.externalData.externalResourceName} onChange = {this.handleExternalNameChange} style={{ height: '140%' }}/>
                        </GridCell>
                        <GridCell span="4">
                            <Reactsel
                                name="levelslist"
                                onChange={this.handleExtAssociatedLevels}
                                value={this.state.externalSelectedLevels}
                                options={this.state.externalData.comboLevels}
                                placeholder="--Select Level--"
                                isMulti>
                            </Reactsel>
                        </GridCell>

                        <GridCell span="5">
                            <Reactsel
                                name="levelslist"
                                onChange={this.handleExtAssociatedTracks}
                                value={this.state.externalSelectedTracks}
                                options={this.state.externalData.comboTracks}
                                placeholder="--Select Track--"
                                isMulti>
                            </Reactsel>
                        </GridCell>
                        <GridCell span="3">
                            <input type="file" id="PdfUpload" name="artifact" onChange={this.validateUpload} />
                        </GridCell>
                        <GridCell span="3">
                            <TextField fullwidth label="Author" name="resourceauthor" value = {this.state.externalData.externalAuthor} onChange={this.handleExternalAuthorChange} style={{ height: '140%' }}/>
                        </GridCell>
                        <GridCell span="9">
                            <TextField textarea fullwidth label="Description" rows="1" name="resourcedesc" value = {this.state.externalData.externalDescription} onChange={this.handleExternalDescChange} />
                        </GridCell>
                        <GridCell span="4"> 
                            {uploadButtonComponent}
                        </GridCell>
                        <GridCell span="4">
                            <Button style={{ width: '100%' }} onClick= {((e) => handleUploadFormClose(e))}>Cancel</Button>
                        </GridCell>
                        <GridCell span="2">
                        </GridCell>
                    </Grid>
                    </form>
                    <StatusMessage error_msg = {this.state.errorMsg} />
                    <StatusMessage error_msg = {this.state.fileError} />
                </div>
            )
        }
    	
    	if (this.props.externalResourceDetails != undefined && this.props.externalResourceDetails.length > 0){
    		externalComponent = (
    			<div>
    				{this.props.externalResourceDetails.map(function(resource){
    					return(
                            <div key={resource.id}>
                                <AdminIndividualExtResComponent extResourceId = {resource.id}
                                extResourceName = {resource.name}
                                extResourceLink = {resource.resource_link}
                                extResourceType = {resource.resource_type}
                                extResourceAuthor = {resource.author}
                                extResourceDescription = {resource.description} 
                                extResourceRating = {resource.rating} 
                                extResourceDate = {resource.date} />
                            </div>
    					)
    				})}
    			</div>
    		)
    	}
    	else {
    		externalComponent = (
    			<Grid>
    				<GridCell span="12">
    					<Typography>There are no resources!</Typography>
    				</GridCell>
    			</Grid>
    		);
    	}	
    
   		return(
            <Grid>
                <GridCell span="10">
                    <Card style={{padding: '25px'}}>
                        <Typography use="headline6" align="left">External Resource <Button dense style={{ width: '10%' }} onClick= {((e) => handleUploadFormOpen(e))}>Upload</Button> <Button dense style={{ width: '10%' }} onClick= {((e) => handleAddFormOpen(e))}>Add</Button> </Typography>
                        {externalAddCompenent}
                        {externalComponent}
                    </Card>
                    {Snackbarcomponent}
                </GridCell>
            </Grid>
    	);
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminExternalResource);


// WEBPACK FOOTER //
// ./src/views/admin/AdminExternalResource.jsx